import { isDeveloper } from "../../../../../lib/script";
import Card from "../../../../common/Card";
import PannelHeader from "../../../../fragments/PannelHeader";
import PannelBody from "../../../../fragments/PannelBody";
import { useSelector } from "react-redux";

export default function DevOnly() {
    const activeCase = useSelector(state => state.case.activeCase);

    return <>    
    {isDeveloper() && <Card>
            <PannelHeader>
                <h2>NG Data</h2>
            </PannelHeader>
            <PannelBody>
                <p>Patient ID: {activeCase?.patient?.person_number}</p>
                <p>Case ID: {activeCase?.case?.id}</p>
                <p>NG ID: {activeCase?.patient?.nextgen_id}</p>
            </PannelBody>
        </Card>}
    </>
}